<template>
  <div class="container min-vh-100 d-flex align-items-center justify-content-center">
    <div class="card shadow-sm w-100" style="max-width: 400px; border-radius: 18px;">
      <div class="card-body d-flex flex-column align-items-center p-4">
        <img alt="logo" class="mb-3 rounded logo" src="@/assets/image.png" />
        <h2 class="h5 fw-bold text-center mb-3">Buka di Aplikasi "Hai Parahita"</h2>
        <div class="middle-card border w-100 mb-3 py-3 px-2 d-flex flex-column align-items-center">
          <p class="mb-2 text-center fw-400 color-neutral-600">Klik tombol di bawah untuk melanjutkan login di aplikasi</p>
          <div class="d-flex align-items-center fs-4 mb-2 gap-2">
            <span>📋</span>
            <span class="text-primary">↓</span>
            <span class="text-primary"></span>
          </div>
          <p class="mb-0 text-center fw-400 color-neutral-600">Anda akan diarahkan ke aplikasi untuk menyelesaikan login</p>
        </div>
        <div class="fw-400 fs-12 color-neutral-600 mb-2 text-center">Powered by Parahita</div>
        <a
          :href="appStoreLink"
          class="btn btn-primary w-100 mb-2 rounded-pill fw-semibold"
          @click.prevent="copyAndOpenApp"
        >Buka di Aplikasi</a>
        <button
          class="btn btn-outline-secondary w-100 rounded-pill fw-semibold"
          :disabled="loading"
          @click="$emit('loginBrowser')"
        >{{ loading ? 'Memproses...' : 'Lanjutkan di Browser' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['loginBrowser'],
  setup () {
    const appStoreLink = 'https://apps.apple.com/us/app/hai-parahita/id1574198986'

    const copyAndOpenApp = async () => {
      try {
        await navigator.clipboard.writeText(window.location.href)
      } catch (err) {
        // ignore clipboard error
      }
      window.location.href = appStoreLink
    }

    return {
      appStoreLink,
      copyAndOpenApp
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  width: 200px;
  object-fit: contain;
}
.middle-card {
  border-radius: 12px;
}
</style>
